document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver((mutations, obs) => {
    const submitBtn = document.querySelector("button[type='submit'].bold_hidden");
    if (submitBtn) {
      obs.disconnect();
      const form = document.querySelector("form.shopify-product-form");
      submitBtn.addEventListener("click", (e) => {
        e.preventDefault();
        let formData = new FormData(form);
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          body: formData,
        })
          .then((response) => {
            window.Rebuy.SmartCart.show();
            return response.json();
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      });
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});